import { useContext } from 'react';
import { invariant } from '../../../../@react-dnd/invariant/dist/esm/d3abb5e672e7778a38d58eaa2ecad8bcd52c0adee27175788c7c8d2b86512d43.cfe-internal.js';
import '../core/477ce5ef01eecc050535ae617b561edb0ea89451f8bd95b0104ae5b0787f9909.cfe-internal.js';
import { DndContext } from '../core/801e8f0253a7757d69bdfd073e114896d25e080494d1b1d2d7f88c11b86b3d19.cfe-internal.js';

/**
 * A hook to retrieve the DragDropManager from Context
 */
function useDragDropManager() {
  var _useContext = useContext(DndContext),
    dragDropManager = _useContext.dragDropManager;
  invariant(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}

export { useDragDropManager };
